// F8 (fase 2, corte 6) — ¿esta receta agenda visitas? Sólo cuando su
// contraparte del asset es EXTERNA (no entra al dashboard: el propietario
// de postventa). Facility declara asset_party (el jefe de tienda) pero es
// personal: no agenda. La misma señal que `assetPartyBinding(recipe)
// .audience === "external"` en core-api, para que el dashboard decida si
// muestra los campos de la visita sin una rama por slug.
import { resolveAssetPartyMemberRole } from "@bitacorapro/core-engine";
import { isDashboardShellRole } from "./auth.js";
export function observationVisitsEnabled(recipe) {
    if (!recipe)
        return false;
    const role = resolveAssetPartyMemberRole(recipe);
    return role !== null && !isDashboardShellRole(role.key);
}
//# sourceMappingURL=observation-visit.js.map